import { useState } from "react";
import {
  Datagrid,
  TextField,
  NumberField,
  EditButton,
  DeleteButton,
} from "react-admin";

import TopicOrderableList from "./TopicOrderableList";
import resources from "../../constants/resources";
import { TopicActions, TopicFilter } from "./TopicUtilsComponents";
import { ListStyles } from "../../styles/commonStyles";

const TopicList = () => {
  const [isShowingTopicOrderable, setIsShowingTopicOrderable] = useState(false);

  const topicOrderableHandle = () => {
    setIsShowingTopicOrderable(!isShowingTopicOrderable);
  };

  return isShowingTopicOrderable ? (
    <TopicOrderableList
      topicOrderableHandle={topicOrderableHandle}
      isShowingTopicOrderable={isShowingTopicOrderable}
    />
  ) : (
    <ListStyles
      actions={
        <TopicActions
          topicOrderableHandle={topicOrderableHandle}
          isShowingTopicOrderable={isShowingTopicOrderable}
        />
      }
      path={resources.TOPIC.url}
      title={resources.TOPIC.title}
      perPage={25}
      filters={<TopicFilter />}
      exporter={false}
      sort={{ field: "order", order: "ASC" }}
    >
      <Datagrid bulkActionButtons={false}>
        <TextField source="id" sortable={false} />
        <TextField source="name_en" sortable={false} />
        <TextField multiline="true" source="description_en" sortable={false} />
        <NumberField source="order" />
        <EditButton />
        <DeleteButton mutationMode="pessimistic" />
      </Datagrid>
    </ListStyles>
  );
};

export default TopicList;
